import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Heading1,
  Heading3,
  Paragraph,
  Heading2,
  LinkStyled,
} from '../../components/typography';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';
import Datoer from '../../components/Datoer';

export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="Jul">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>Juleøl</Heading1>
          <Paragraph bold>J-dag: <Datoer type="julebryg" /></Paragraph>
        </Col>
        <Col xs={12}>
          <Paragraph>
            Det er næsten umuligt at sige klassisk dansk julefrokost, uden også at sige god juleøl. Julen er fyldt med traditioner og den tilhørende juleøl til julefrokosten er en vigtig en af dem. Hos Skafte finder du mange forskellige juleøl på fad, både de klassiske, men også mere specielle øl fra små bryggerier. Én ting er sikkert: de sætter alle sammen gang i julestemningen.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="fadoelJuleoel" filterFadkobling filterLiterSize filterLiterPrice display={ProductView1} showTypeFadoel />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Juleøl på fad byder julestemningen indenfor</Heading2>
          <Paragraph>
            Den er sikker hvert eneste år. De traditionsrige julefrokoster melder deres ankomst omkring november måned og fortsætter helt indtil jul - og de kalder selvfølgelig på en god juleøl, der er med til at understøtte maden og den skønne julestemning.
            Hos Skafte finder du smagfulde juleøl på fad, der er perfekte til jeres kommende julefrokoster og som med garanti bliver et kæmpe hit ved julebordet. Uanset om du er til de klassiske juleøl som fx Tuborg og Royal eller om I skal give jer i kast med specielle juleøl, så finder du dem alle på fad hos os.
            Selvom juleøl er traditionsrig og har en skøn dyb smag, så er det ikke alle, der er vilde med smagen. <LinkStyled to="/fadoel">Køb fadøl</LinkStyled> i andre varianter ved siden af juleøllen og vær helgarderet, så alle kan tage del af øl-julehyggen, hvis de har lyst.
          </Paragraph>
          <Paragraph>
            Juleøl er som bekendt en sæsonvare og du derfor kan bestille alle vores lækre typer julebryg allerede fra november måned. Du finder fx datoen for J-dag øverst på siden.
            Alle fustager kommer i en størrelse mellem 20 - 30 liter, afhængigt af typen af juleøl.
          </Paragraph>
          <Paragraph>
            Vi kan stå for både levering, opsætning og returtagning af resterende fustager og udstyr. Så skal du blot bekymre dig om at købe nok sild, æg og øl - og selvfølgelig have en skøn julefrokost med venner, bekendte, familie eller kollegaer.
            Du har også mulighed for selv at hente din juleøl på fad fra vores lager i Brøndby.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Juleøl i mange varianter</Heading2>
          <Paragraph>
            Hos Skafte finder du mange forskellige varianter af juleøl. Alle juleøllene har de klassiske karaktertræk, men adskiller sig dog alligevel fra hinanden, alt efter hvilke du vælger. Hvilken julebryg skal i fadølshanerne til din julefrokost eller -fest? Nedenfor kan du læse om nogle af vores varianter af juleøl:
          </Paragraph>
        </Col>
        <Col xs={12} md={6}>
          <Heading3>Tuborg Julebryg</Heading3>
          <Paragraph>
            Nok Danmarks mest populære og velkendte juleøl, som endda har sin egen mærkedag, J-dag, der ligger den 1. fredag i november hvert år og har gjort det siden 1981.
            Dette er en juleøl, med kraftig fylde og let bitterhed. En mørk øl med 5,6% alkohol.
          </Paragraph>
        </Col>
        <Col xs={12} md={6}>
          <Heading3>Nørrebro Jule IPA</Heading3>
          <Paragraph>
            En juleøl af typen IPA (India Pale Ale). En god og fyldig juleøl med en stærk alkoholprocent på 6,3% og en skøn frugtig smag, med en god bitterhed og toner af appelsin.
          </Paragraph>
        </Col>
        <Col xs={12} md={6}>
          <Heading3>Royal Xmas Blågran</Heading3>
          <Paragraph>
            En mørk juleøl af pilsner typen. Denne juleøl er efterhånden en klassiker og har en fyldig og sødmefuld krop, samt en behagelig bitterhed og en snert af engelsk lakrids. Duftnoterne byder på ristet karamel. Alkoholprocent på 5,3%.
          </Paragraph>
        </Col>
        <Col xs={12} md={6}>
          <Heading3>Anarkist Santas Fruit</Heading3>
          <Paragraph>
            En skøn IPA juleøl, der er brygget med fokus på at skabe en øl, der passer perfekt til julemaden. Juleøllen er gylden og uklar og smagen er dyb og med noter af mandarin. Alkoholprocenten ligger på 5,9%.
          </Paragraph>
        </Col>
        <Col xs={12} md={6}>
          <Heading3>Anarkist Christmas Ale</Heading3>
          <Paragraph>
            Skøn juleøl med en kompleks maltprofil og en spændende sammensætning af humle. Smagfuld karakter, der supplerer de traditionelle julesmage og juleretter, men er også god at nyde alene. Har en alkoholprocent på 6,2%.
          </Paragraph>
        </Col>
        <Col xs={12} md={6}>
          <Heading3>Skovlyst Julebryg</Heading3>
          <Paragraph>
            Juleøl af typen mørk ale, der har en krydret karakter og en alkoholprocent på 5,7%. Denne juleøl får sin mørke og gyldne farve fra forskellige sukkerstoffer, heriblandt brun farin. Der tilsættes en ekstrakt fra grankviste i eftergæringsprocessen, hvilket gør, at juleøllen får en friskere smag.
          </Paragraph>
        </Col>
        <Col xs={12} md={6}>
          <Heading3>Svaneke Øko Julebryg</Heading3>
          <Paragraph>
            Lækker nøddebrun lager juleøl, hvor duften præges af både karamel, alkohol og humle. Karamelmalt er med til at sætte et stort aftryk på smagen og en diskret sødme balancerer i eftersmagen. Alkoholprocent på 5,7%.
          </Paragraph>
        </Col>
        <Col xs={12} md={6}>
          <Heading3>Grimbergen Noël</Heading3>
          <Paragraph>
            Juleøl med en smuk klar og kobberbrun farve. Let fyldig mørk ale med en alkoholprocent på 6,5% og en eftersmag, der byder på noter af sød lakrids.
          </Paragraph>
        </Col>
        <Col xs={12} md={6}>
          <Heading3>Jacobsen Christmas Ale</Heading3>
          <Paragraph>
            Smuk juleøl med en gyldenbrun farve og en tæt, flødefarvet skum. Fyldig sødme fra malt og en rund bitterhed i eftersmagen i skøn balance. Duften præges af både appelsin, kanel og lakrids. Alkoholprocenten er på 7,5% og er derfor en stærk juleøl.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Hvad gør juleøllen så speciel?</Heading2>
          <Paragraph>
            Ligesom ved klassisk og almindelig øl, brygges juleøl på mange forskellige metoder, afhængigt af producenten.
          </Paragraph>
          <Paragraph>
            Men hvad gør juleøl så specielt? Det er kombinationen af rige malte, krydderier og ofte en højere alkoholprocent. Smagen? Oftest en dyb, sødmefuld profil med noter af karamel, krydderier og undertiden frugt.
            Det er ikke bare en øl; det er en oplevelse. Og når du tapper julebryggen fra et fadølsanlæg, bliver smagen endnu mere autentisk og frisk. Det er den perfekte ledsager til den danske julemad og de kolde vinteraftener.
          </Paragraph>
          <Paragraph>
            Den typiske og traditionelle julemad karakteriseres ofte af fedme og salt, og disse smagsnoter komplimenteres exceptionelt godt af juleøl. Smagsnoterne i både mad og juleøl er nemlig et hit i samspil med hinanden, da de både balancerer og forstærker.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Få leveret din juleøl direkte til døren</Heading2>
          <Paragraph>
            Skafte leverer både til private og til virksomheder, der i den søde juletid forkæler familie, venner og kollegaer med en julefrokost eller -fest.
            Vi kan stå for både levering, opsætning og returtagning, så det eneste du skal bekymre dig om er, at nyde den skønne stemning til julefrokosten.
          </Paragraph>
          <Paragraph>
            Slip for at skulle bakse rundt med de tunge fustager af juleøl, men nyd i stedet godt af Skaftes service, hvor vi bærer øl, anlæg mv. nøjagtigt hvor du vil have det. Så bliver det næsten ikke lettere.
          </Paragraph>
          <Paragraph>
            Skal du også bruge <LinkStyled to="/fadoelsanlaeg">fadølsanlæg</LinkStyled> og evt. en <LinkStyled to="/fadoelsbar">bar</LinkStyled> til arrangementet? Du finder netop den størrelse som du har brug for, så julefesten bliver et hit!
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Hvornår kan man købe juleøl?</Heading2>
          <Paragraph>
            Der er nedtælling til juleaften.. Men før det, er der nedtælling til, hvornår man kan købe juleøl.
          </Paragraph>
          <Paragraph>
            Den faste tradition om J-dag er startet af Tuborg, der har skabt sin egen mærkedag, der fejrer, at Tuborg Julebryg kommer på markedet og kan nydes af den danske befolkning.
          </Paragraph>
          <Paragraph>
            J-dag er altid den første fredag i november måned. Og det er faktisk også samme dag, hvor du kan klikke de andre lækre varianter af julebryg fra andre producenter hjem. Lige tidsnok til at årets mange julefrokoster begynder at kalde.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>En høj juleøl procent</Heading2>
          <Paragraph>
            Langt de fleste juleøl og julebryg har en højere alkoholprocent end en almindelig pilsner. Dette skyldes, at man i gamle dage gemte og serverede en stærkt lagret øl. Til hverdag drak man en tynd øl, men juletiden kaldte på en ekstra god stemning.
          </Paragraph>
          <Paragraph>
            En juleøls alkoholprocent ligger oftest mellem 5,5% og 6,5%.
          </Paragraph>
          <Paragraph>
            Juleøl bør ikke forveksles med nisseøl, trods det julede navn. Nisseøl har nemlig en langt højere sødme, men også en meget lav alkoholprocent på ca. 1,7-1,9%.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
